import { render } from "./CreateBroadcastSubKomunitasView.vue?vue&type=template&id=47bfe3ce"
import script from "./CreateBroadcastSubKomunitasView.vue?vue&type=script&lang=js"
export * from "./CreateBroadcastSubKomunitasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__